import { render, staticRenderFns } from "./AdminBidButton.vue?vue&type=template&id=0980f71a"
import script from "./AdminBidButton.vue?vue&type=script&lang=js"
export * from "./AdminBidButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports